import "./home.css";

import React from "react";

import { BACKGROUNDS, HOME, ROUTES } from "../../data/content";
import PageMeta from "../general/PageMeta";
import { LinkButton, PageBackground } from "../general/PageSections";
import Testimonials from "../general/Testimonials";

const Home = () => {
  return (
    <div className={"home"}>
      <PageMeta
        title={HOME.TITLE}
        description={HOME.DESCRIPTION}
        isFullTitle
      />
      <PageBackground src={BACKGROUNDS.HOME} />

      <section className={"home-hero"}>
        <h1 className={"home-hero-logo"}>
          <img
            src={"/images/logo-white.png"}
            alt={"Candlewoods Guesthouse"}
            width={1200}
            height={523}
          />
        </h1>
      </section>

      <div className={"home-band"}>
        <section className={"home-welcome container"}>
          <h2 className={"home-welcome-title"}>{HOME.WELCOME_TITLE}</h2>
          <hr className={"rule is-centered"} />
          <p className={"home-welcome-text"}>{HOME.WELCOME}</p>

          <ul className={"home-cards"}>
            {HOME.CARDS.map((card) => (
              <li
                key={card.title}
                className={"home-card"}
              >
                <h3 className={"home-card-title"}>{card.title}</h3>
                <p className={"home-card-text"}>{card.text}</p>
                <hr className={"rule is-centered"} />
                <LinkButton
                  path={card.path}
                  href={card.href}
                  className={"btn is-light home-card-button"}
                >
                  Read More
                  <span className={"visually-hidden"}>
                    {" "}
                    about {card.title.toLowerCase()}
                  </span>
                </LinkButton>
              </li>
            ))}
          </ul>
        </section>

        <div
          className={"home-strip"}
          style={{ backgroundImage: `url(${HOME.STRIP.src})` }}
          role={"img"}
          aria-label={HOME.STRIP.alt}
        />

        <div className={"home-reviews container"}>
          <Testimonials items={HOME.TESTIMONIALS} />
          <LinkButton path={ROUTES.BOOK}>Book A Room</LinkButton>
        </div>
      </div>

      {/* Gap before the footer where the background photo shows through, as on Wix */}
      <div className={"home-gap"} />
    </div>
  );
};

export default Home;
